module.exports = __webpack_public_path__ + "img/biobank-logo-color.e5081984.png";